import { useQuery } from "@tanstack/react-query";
import userService from "@/lib/services/userService";
import regionsService from "@/lib/services/regionsService";
import { useAuthStore } from "./authStore";
import { Region, UserProfile } from "@/lib/services/types";

export const useUser = (): {
  user: UserProfile;
  isLoading: boolean;
  error: Error | null;
} => {
  const {
    data: profile,
    isLoading,
    error,
  } = useQuery({
    queryKey: ["userProfile"],
    queryFn: userService.getProfile,
    staleTime: 5 * 60 * 1000,
    retry: 3,
    enabled: useAuthStore.getState().isAuthenticated,
  });

  return {
    user: profile as UserProfile,
    isLoading,
    error,
  };
};

export const useRegion = (): {
  regionData: Region;
  isLoading: boolean;
  error: Error | null;
} => {
  const { data, isLoading, error } = useQuery({
    queryKey: ["user-region"],
    queryFn: regionsService.getRegion,
    enabled: useAuthStore.getState().isAuthenticated,
  });

  return { regionData: data as Region, isLoading, error };
};
